import { useCallback, useRef } from 'react';

const useHideLastChildOnOverflow = () => {
  const resizeObserverRef = useRef(null);

  const containerRef = useCallback(node => {
    if (resizeObserverRef.current) resizeObserverRef.current.disconnect();
    if (node === null) return;

    resizeObserverRef.current = new ResizeObserver(() => {
      const children = Array.from(node.children);
      const childrenHeight = children
        .map(child => child.offsetHeight)
        .reduce((acc, curr) => acc + curr, 0);

      const containerHeight = node.offsetHeight;
      const isOverflowing = childrenHeight > containerHeight;

      const lastChild = children[children.length - 1];
      if (lastChild) {
        lastChild.style.opacity = isOverflowing ? 0 : 1;
      }
    });

    Array.from(node.children).forEach(child => {
      resizeObserverRef.current.observe(child);
    });
  }, []);

  return { containerRef };
};

export default useHideLastChildOnOverflow;
